import { render } from "./NonBenchmarkView.vue?vue&type=template&id=ddbb1656&scoped=true"
import script from "./NonBenchmarkView.vue?vue&type=script&lang=js"
export * from "./NonBenchmarkView.vue?vue&type=script&lang=js"

import "./NonBenchmarkView.vue?vue&type=style&index=0&id=ddbb1656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbb1656"]])

export default __exports__